import { Component, Input, SimpleChanges } from '@angular/core';
import { NavController } from 'ionic-angular';
import { CommonProvider } from '../../providers/common/common';

@Component({
  selector: 'shop-data',
  templateUrl: 'shop-data.html'
})
export class ShopDataComponent {
  is_pc:boolean;
  is_click: boolean = true;
  @Input() shop_list = [];
  @Input() is_top: boolean;
  shop_disp = [];
  begin:number = 0;
  //is_up:boolean = false;
  is_down:boolean = false;
  is_scroll:boolean = false;
  add_count:number = 20;
  wait_time:number = 500;

  constructor(
    public navCtrl: NavController,
    public comProv: CommonProvider,
  ) {
    this.is_pc = this.comProv.isPc();
    if (this.comProv.isAndroid()) {
      this.wait_time = 100;
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['shop_list']) {
      if (this.is_pc) {
        this.shop_disp = this.shop_list;
        return;
      }
      // 初期化
      this.shop_list = changes['shop_list'].currentValue;

      let brand_list = this.comProv.getBrandList();
      this.shop_list.forEach(function(item) {
        item['brand_image'] = null;
        if (item['brand_id']) {
          let brand_data = brand_list.find((value) => {
            return (value['id'] == item['brand_id']);
          });
          if (brand_data) {
            item['brand_image'] = brand_data['image_url'];
          }
        }
      });

      this.begin = 0;
      this.shop_disp = [];

      this.shop_disp = this.shop_list.slice(this.begin, this.begin + this.add_count);
      this.begin += this.add_count;
      this.checkAdd();
    }
  }

  /*doUp(infiniteScroll) {
    if (this.begin <= (this.add_count * 2)) {
      infiniteScroll.complete();
      return;
    }
    if (this.is_scroll) {
      infiniteScroll.complete();
      return;
    }
    this.is_scroll = true;
    console.log('doUp', this.begin);
    setTimeout(() => {
      // 追加
      let add_list = this.shop_list.slice(this.begin - (this.add_count * 3), (this.begin - this.add_count * 2));
      add_list.reverse();
      for (let i=0; i<add_list.length; i++) {
        this.shop_disp.unshift(add_list[i]);
      }
      
      // 削除
      if (this.shop_disp.length > (this.add_count * 2)) {
        this.shop_disp.splice((this.add_count * 2), this.add_count);
      }

      // スクロール制御
      this.begin -= this.add_count;
      this.checkAdd();
      infiniteScroll.complete();
      this.is_scroll = false;
    }, this.wait_time)
  }*/

  doDown(infiniteScroll) {
    if (this.shop_list.length <= this.begin) {
      infiniteScroll.complete();
      return;
    }
    if (this.is_scroll) {
      infiniteScroll.complete();
      return;
    }
    this.is_scroll = true;
    console.log('doDown', this.begin);
    setTimeout(() => {
      // 追加
      let add_list = this.shop_list.slice(this.begin, this.begin + this.add_count);
      for (let i=0; i<add_list.length; i++) {
        this.shop_disp.push(add_list[i]);
      }

      // 削除
      /*if (this.begin > this.add_count) {
        for (let i=0; i<this.add_count; i++) {
          this.shop_disp.shift();
        }
      }*/

      // スクロール制御
      this.begin += this.add_count;
      this.checkAdd();
      infiniteScroll.complete();
      this.is_scroll = false;
    }, this.wait_time)
  }

  checkAdd() {
    /*if (this.begin > (this.add_count * 2)) {
      this.is_up = true;
    } else {
      this.is_up = false;
    }*/

    if (this.shop_list.length > this.begin) {
      this.is_down = true;
    } else {
      this.is_down = false;
    }
  }

  goDetail(shop_data) {
    if (this.is_top) {
      return;
    }
    this.navCtrl.push('ShopDetailPage',{
      shop_data: shop_data,
      shop_id: shop_data['id']
    });
  }
}


// WEBPACK FOOTER //
// ./src/components/shop-data/shop-data.ts